import store from '@/store'
// helpers
import eventBus from '@/helpers/event-bus'
// events
import btnClicked from './events/btnClicked'
import rowCreated from './events/rowCreated'
import rowUpdated from './events/rowUpdated'
import fieldUpdated from './events/fieldUpdated'

/**
 * Parse workflows and convert JSON to object
 * @param {Object} wf - workflows collection
 */
function parseWorkflows(wf) {
  const workflows = {}

  if (!wf) return workflows

  for (let wfKey in wf) {
    try {
      workflows[wfKey] = JSON.parse(wf[wfKey])
    } catch (err) {
      console.error(err)
    }
  }

  return workflows
}

/**
 * Apply events according to workflow
 * @param {Object} wf - workflows collection
 */
export function swfApply(wf) {
  const workflows = parseWorkflows(wf)

  for (let workflowKey in workflows) {
    const workflow = workflows[workflowKey]

    try {
      switch(workflow.whenTrigger) {
        case 'btnClicked':
          btnClicked(workflow, eventBus)
          break
        case 'rowCreated':
          rowCreated(workflow, eventBus)
          break
        case 'rowUpdated':
          rowUpdated(workflow, eventBus)
          break
        case 'fieldUpdated':
          fieldUpdated(workflow, eventBus)
          break
      }
    } catch (err) {
      console.error(err)
    }
  }
}

/**
 * Release events according to workflow
 * @param {Object} wf - workflows collection
 */
export function swfRelease(wf) {
  const workflows = parseWorkflows(wf)

  for (let workflowKey in workflows) {
    const workflow = workflows[workflowKey]

    switch (workflow.whenTrigger) {
      case 'btnClicked':
        eventBus.$off(`simpleWorkflow-btnClicked-${workflow.sourceGrid}`)
        break
      case 'rowCreated':
        eventBus.$off(`simpleWorkflow-rowCreated-${workflow.sourceGrid}`)
        break
      case 'rowUpdated':
        eventBus.$off(`simpleWorkflow-rowUpdated-${workflow.sourceGrid}`)
        break
      case 'fieldUpdated':
        eventBus.$off(`simpleWorkflow-fieldUpdated-${workflow.sourceGrid}-${workflow.cellKey}`)
        break
    }
  }
}
